import { runtimeConfig } from "@/lib/runtime-config"

// Configuracao publica do login (nada aqui e segredo). Vem de /config.js (runtime, imagem) ou do build (Vite define).
export function getPrivyConfig(): { appId: string | null; clientId: string | null } {
  const config = runtimeConfig()
  return {
    appId: (config.privyAppId || process.env.NEXT_PUBLIC_PRIVY_APP_ID)?.trim() || null,
    clientId: (config.privyClientId || process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID)?.trim() || null,
  }
}

/** Site onde a conta e a carteira nascem; este app so entra. */
export function getCyrcloTechUrl(): string {
  return (runtimeConfig().cyrclotechUrl || process.env.NEXT_PUBLIC_CYRCLO_TECH_URL)?.trim() || "https://cyrclo.tech"
}
